import { frontendSkillRegistry } from './registry';
// WICHTIG: Alle Skills werden über ihre schlanken manifest.ts-Descriptoren
// importiert — NIE über den Barrel (index.ts). Die Barrels re-exportieren
// Seiten und APIs (TrainingPage inkl. Markdown, PrueferListPage, Lunr-Index …),
// die App.tsx via React.lazy() in eigene Chunks legt. Ein statischer
// Barrel-Import hier würde das Code-Splitting komplett aushebeln, weil
// bootstrap.ts statische Dependency des Entry (main.tsx) ist.
// Slot-Renderer in den Manifests dürfen React.lazy sein — <SkillSlot> bringt
// pro Eintrag eine eigene Suspense-Boundary.
import { contactManagementSkill } from '../contact-management/manifest';
import { collaborationAssignmentsSkill } from '../collaboration-assignments/manifest';
import { smartSearchSkill } from '../smart-search/manifest';
import { dataImportSkill } from '../data-import/manifest';
import { projectVersioningSkill } from '../project-versioning/manifest';
import { notificationsSkill } from '../notifications/manifest';
import { feedbackSkill } from '../feedback/manifest';
import { commentsMentionsSkill } from '../comments-mentions/manifest';
import { projectTimelineSkill } from '../project-timeline/manifest';
import { helpCenterSkill } from '../help-center/manifest';
import { projectAssistantSkill } from '../project-assistant/manifest';
import { aiTextRewriteSkill } from '../ai-text-rewrite/manifest';
import { aiFieldPrefillSkill } from '../ai-field-prefill/manifest';
import { projectCloningSkill } from '../project-cloning/manifest';
import { inputClipboardCaptureSkill } from '../input-clipboard-capture/manifest';
import { inputRepositorySkill } from '../input-repository/manifest';
import { projectPortfolioSkill } from '../project-portfolio/manifest';
import { provenanceFrontendSkill } from '../provenance/manifest';
import { floorPlanEditorSkill } from '../floor-plan-editor/manifest';
import { aiSmartAssistantSkill } from '../ai-smart-assistant/manifest';
import { documentGenerationSkill } from '../document-generation/manifest';
import { templatesSkill } from '../templates/manifest';
import { prueferSkill } from '../pruefer/manifest';
import { behoerdenvorgangSkill } from '../behoerdenvorgang/manifest';
import { mailInboundSkill } from '../mail-inbound/manifest';
import { trainingSkill } from '../training/manifest';
import { timeTrackingSkill } from '../time-tracking/manifest';
import { voiceControlSkill } from '../voice-control/manifest';

/**
 * Registriert alle bekannten Frontend-Skills.
 * Wird einmal aus main.tsx vor dem Render aufgerufen.
 *
 * Bewusst statisch — wenn die Liste > 5 wird, mit Vite-glob auto-loaden.
 */
export function bootstrapSkills(): void {
  frontendSkillRegistry.register(contactManagementSkill);
  frontendSkillRegistry.register(collaborationAssignmentsSkill);
  frontendSkillRegistry.register(smartSearchSkill);
  frontendSkillRegistry.register(dataImportSkill);
  frontendSkillRegistry.register(projectVersioningSkill);
  frontendSkillRegistry.register(notificationsSkill);
  frontendSkillRegistry.register(feedbackSkill);
  frontendSkillRegistry.register(commentsMentionsSkill);
  frontendSkillRegistry.register(projectTimelineSkill);
  frontendSkillRegistry.register(helpCenterSkill);
  frontendSkillRegistry.register(projectAssistantSkill);
  frontendSkillRegistry.register(aiTextRewriteSkill);
  frontendSkillRegistry.register(aiFieldPrefillSkill);
  frontendSkillRegistry.register(projectCloningSkill);
  frontendSkillRegistry.register(inputClipboardCaptureSkill);
  frontendSkillRegistry.register(inputRepositorySkill);
  frontendSkillRegistry.register(projectPortfolioSkill);
  frontendSkillRegistry.register(provenanceFrontendSkill);
  frontendSkillRegistry.register(floorPlanEditorSkill);
  frontendSkillRegistry.register(aiSmartAssistantSkill);
  frontendSkillRegistry.register(documentGenerationSkill);
  frontendSkillRegistry.register(templatesSkill);
  frontendSkillRegistry.register(prueferSkill);
  frontendSkillRegistry.register(behoerdenvorgangSkill);
  frontendSkillRegistry.register(mailInboundSkill);
  frontendSkillRegistry.register(trainingSkill);
  frontendSkillRegistry.register(timeTrackingSkill);
  frontendSkillRegistry.register(voiceControlSkill);
}
